import { InfoOutlined as InfoIcon } from '@mui/icons-material';

const InfoOutline = (): JSX.Element => <InfoIcon fontSize="inherit" />;

export default InfoOutline;
